import Api from "../config/Axios";

// Permission List
export const getPermissionList = (token, user_id) => {
  const config = {
    headers: {
      Authorization: "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get("api/web/permissions", config);
};